import type { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'
import createSearchContext from 'analytics/snowplow/helpers/createSearchContext'

type SearchContext = comluxgroup.SearchContext_1_1_1
type HomesCrossSellBannerVariant = 'urban' | 'leisure'

export function trackHomesCrossSellBannerImpression(variant: HomesCrossSellBannerVariant, searchContext: SearchContext): void {
  trackClientEvent({
    subject: `homes_cross_sell_banner_${variant}`,
    action: 'impression',
    category: 'search',
    type: 'nonInteraction',
    context: [createSearchContext(searchContext)],
  })
}

export function trackHomesCrossSellBannerClick(variant: HomesCrossSellBannerVariant, searchContext: SearchContext): void {
  trackClientEvent({
    subject: `homes_cross_sell_banner_${variant}`,
    action: 'click',
    category: 'search',
    type: 'interaction',
    context: [createSearchContext(searchContext)],
  })
}
